import React, { FC } from "react";
import { Col, Row, Skeleton } from "antd";
import EmptyState from "../../../../../shared/components/EmptyState";
import moment from "moment";

//model
import { Subscription } from "../../../../../models/SubscriptionModel/subscription.model";

interface ActiveSubscriptionsProps {
    data: Subscription[];
}

const ActiveSubscriptions: FC<ActiveSubscriptionsProps> = (props) => {
    const { data } = props;
    return (
        <>
            <div className='details__title'> Active subscription</div>
            {data.length
                ? <Row gutter={[16, 24]} >
                    {data.map((data: any, i: number) => (
                        <Col span={11} xs={24} sm={24} md={11} className="subscription__details">
                            <div className="subscription-details__wrapper">
                                <div className="subscription-profile__wrapper">
                                    {/* <img src={subscriptionDetails?.} /> */}
                                    <div className="subscription-name__wrapper">
                                        <p className="subscription__name">{data?.name}</p>
                                        <p>{data?.boardName}</p>
                                    </div>
                                </div>
                                <Row className="subscription-institute-details__wrapper">
                                    <Col span={12}>
                                        <div className="subscription-instiute__details">
                                            <p >{'Subscribed on'}</p>
                                            <p className="subscription__date">{moment(data?.startDate).format('MMM DD,YYYY')}</p>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="subscription-instiute__details">
                                            <p >{'Valid until'}</p>
                                            <p className="subscription__date">{moment(data?.endDate).format('MMM DD,YYYY')}</p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    ))
                    }
                </Row>
                : <EmptyState text={'No subscriptions found.'} />
            }
        </>
    )
}

export default ActiveSubscriptions;
